import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Col } from 'react-bootstrap';
import { isEqual } from 'lodash';
import { CardList, Pagination } from '@components/common';

import Actions, { thunks } from '@redux/locations';
import LocationCard from './components/locationCard';

class LocationsList extends Component {
	componentDidMount = () => {
		const { getLocationsData } = this.props;
		getLocationsData();
	}

	shouldComponentUpdate = ({
		data, loading, totalCount, filters,
	}) => {
		const lastProps = this.props;

		return (
			!isEqual(data, lastProps.data)
			|| !isEqual(loading, lastProps.loading)
			|| !isEqual(totalCount, lastProps.totalCount)
			|| !isEqual(filters, lastProps.filters)
		);
	}

	onPaginate = (pageNumber) => {
		const {
			updateFilters,
			getLocationsData,
		} = this.props;

		// Update filters
		updateFilters({ pageNumber });

		// Update locationsData after updating the filters
		getLocationsData();
	}

	onClickCard = (Id) => {
		const { history } = this.props;
		history.push(`/locations/${Id}`);
	}

	render() {
		const {
			data,
			loading,
			totalCount,
			filters : {
				displayCount,
				pageNumber,
			},
		} = this.props;

		return (
			<div>
				<Grid>
					<Col
						md={12}
						xs={12}
					>
						<p className="color-dark font-light font-size-40 margin-top-30 margin-bottom-30">List of Locations</p>

						<CardList
							rowKey="Id"
							data={data}
							loading={loading}
							onClickCard={this.onClickCard}
							CardComponent={LocationCard}
							noDataHeader="You don't have any locations yet."
						/>
						<Pagination
							disabled={loading}
							totalCount={totalCount}
							displayCount={displayCount}
							pageNumber={pageNumber}
							onPaginate={this.onPaginate}
						/>
					</Col>
				</Grid>
			</div>
		);
	}
}

const mapStateToProps = ({
	locations : {
		data,
		totalCount,
		filters,
		loading : { data : loading },
	},
}) => ({
	data,
	totalCount,
	filters,
	loading,
});

const mapDispatchToProps = (dispatch) => ({
	updateFilters    : bindActionCreators(Actions, dispatch).updateFilters,
	getLocationsData : bindActionCreators(thunks, dispatch).getLocationsData,

});

LocationsList.propTypes = {
	data             : PropTypes.array,
	getLocationsData : PropTypes.func.isRequired,
	history          : PropTypes.object.isRequired,
	loading          : PropTypes.bool,
	totalCount       : PropTypes.number,
	updateFilters    : PropTypes.func.isRequired,
	filters          : PropTypes.object.isRequired,
};

LocationsList.defaultProps = {
	data       : [],
	loading    : false,
	totalCount : 0,
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationsList);
